import React, { useState } from "react";
import { Flame, ShieldCheck, Wrench, X } from "lucide-react";

const POSTER = "/gallery/stove-12.jpg";
const PREFILL = "Hi, I'd like more details on the Skye 8kW supply & install package (from £3,700).";

const SkyePromo = () => {
  const [open, setOpen] = useState(false);

  const ask = () => {
    window.dispatchEvent(new CustomEvent("prefill-quote", { detail: PREFILL }));
    document.querySelector("#quote-form")?.scrollIntoView({ behavior: "smooth", block: "center" });
    setTimeout(() => document.querySelector('[data-testid="quote-name-input"]')?.focus(), 600);
  };

  return (
    <div className="mt-8 flex gap-4 md:gap-5 p-4 md:p-5 border-l-4 border-fire" style={{ backgroundColor: "#343434" }} data-testid="skye-promo-banner">
      <button onClick={() => setOpen(true)} className="flex-shrink-0 w-24 sm:w-32 md:w-36 overflow-hidden group" aria-label="View the Skye poster" data-testid="skye-poster-button">
        <img src={POSTER} alt="Introducing the Skye - Island Range" className="w-full h-full object-cover object-top transition-transform group-hover:scale-105" />
      </button>
      <div className="text-left min-w-0">
        <p className="text-fire uppercase tracking-[0.2em] text-[11px] font-medium">The first of our Island Range</p>
        <h4 className="text-white text-[22px] md:text-[26px] font-medium leading-tight mt-1">Introducing the Skye</h4>
        <p className="text-white/80 text-[14px] mt-2 leading-snug">
          8kW multifuel stove. Strength, efficiency and timeless style - built for real Scottish homes.
        </p>
        <ul className="mt-3 space-y-1 text-[13px] text-white/90">
          <li className="flex items-center gap-2"><Flame size={14} className="text-fire flex-shrink-0" /> 8kW output, DEFRA approved</li>
          <li className="flex items-center gap-2"><ShieldCheck size={14} className="text-fire flex-shrink-0" /> Twin layer heat shield - sits 150mm from combustibles</li>
          <li className="flex items-center gap-2"><Wrench size={14} className="text-fire flex-shrink-0" /> Supply &amp; install packages from <span className="text-fire font-semibold ml-1">£3,700</span></li>
        </ul>
        <button onClick={ask} className="btn-fire mt-4 px-5 py-2.5 text-[14px]" data-testid="skye-ask-button">
          Ask About The Skye
        </button>
      </div>

      {open && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" data-testid="skye-poster-lightbox">
          <div className="absolute inset-0 bg-black/85" onClick={() => setOpen(false)} />
          <button onClick={() => setOpen(false)} className="absolute top-4 right-4 text-white/80 hover:text-white z-10" aria-label="Close" data-testid="skye-poster-close">
            <X size={30} />
          </button>
          <img src={POSTER} alt="Introducing the Skye - full poster" className="relative max-h-[92vh] max-w-full object-contain shadow-2xl" />
        </div>
      )}
    </div>
  );
};

export default SkyePromo;
